import React from 'react';
import { ProviderMatchBoardCertification } from '@kyruus/types';
import { FormattedMessage } from '@kyruus/intl';

import {
  ExpertiseSectionContainer,
  ExpertiseSectionTitle,
  ExpertiseList
} from './styles';
import BoardCertificationEntry from './board-certification-entry';
import messages from '../../lib/messages';

const BoardCertifications = ({
  board_certifications
}: {
  board_certifications: ProviderMatchBoardCertification[];
}): React.ReactElement | null => {
  // do not render if data not present
  if (!board_certifications || board_certifications.length === 0) {
    return null;
  }

  return (
    <ExpertiseSectionContainer>
      <ExpertiseSectionTitle>
        <FormattedMessage {...messages.boardCertificationsSectionTitle} />
      </ExpertiseSectionTitle>
      <ExpertiseList>
        {board_certifications.map((b, index) => {
          return (
            <BoardCertificationEntry
              key={`${b.board_name}${b.specialty_name}${b.year_certified}${index}`}
              board_certification={b}
            />
          );
        })}
      </ExpertiseList>
    </ExpertiseSectionContainer>
  );
};

export default BoardCertifications;
